export default "__VITE_ASSET__CJH40pFy__"